var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n      You have abandoned the star "),_c('star-label',{attrs:{"starId":_vm.event.data.starId,"starName":_vm.event.data.starName}}),_vm._v(".\n  ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }